<div class="sg-nav-dropdown">
    <nav class="px-3 py-2 container">
        <a [routerLink]="link.url" routerLinkActive="-active" (click)="linkHasBeenClicked()" class="sg-nav-dropdown__link py-1" *ngFor="let link of links">
            {{ link.name }}
        </a>
    </nav>
</div>
